if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.initializeForm = this.initializeForm.bind(this);
        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
      }

      connectedCallback() {
        setTimeout(() => this.initializeForm(), 0);
      }

      initializeForm() {
        this.form = this.querySelector('form');
        if (!this.form) {
          console.error("❌ Form not found inside <product-form> component.");
          return;
        }

        const idField = this.form.querySelector('[name=id]');
        if (idField) idField.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler);

        this.cart = document.querySelector('cart-notification') || 
                    document.querySelector('cart-drawer') || 
                    document.querySelector('cart-dropdown');

        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) {
          console.error("❌ Submit button not found inside <product-form>.");
          return;
        }

        if (document.querySelector('cart-drawer') || document.querySelector('cart-dropdown')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const loadingSpinner = this.querySelector('.loading-overlay__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error("❌ Fetch error:", e);
          })
            .finally(() => {
             this.submitButton.classList.remove('loading');
             this.submitButton.removeAttribute('aria-disabled'); // ✅ Enable button again
             if (loadingSpinner) loadingSpinner.classList.add('hidden');
});

      }
    }
  );
}
